module.exports = __webpack_public_path__ + "img/mountaincabin.f6547f5f.jpg";